import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useT } from "@/i18n/LanguageContext";
import { useSEO } from "@/lib/useSEO";

export default function NotFound() {
  const { t } = useT();
  useSEO({
    title: "Page Not Found | StoicOs Virtue Guide",
    description: "The page you are looking for could not be found. Return to StoicOs Virtue Guide.",
    canonical: "https://stoicos.ai/404",
  });
  return (
    <main data-testid="notfound-page" className="min-h-[70vh] flex items-center justify-center pt-24 pb-20">
      <div className="text-center px-6">
        <p className="text-[11px] tracking-[0.3em] uppercase text-gold mb-6">{t("404.eyebrow")}</p>
        <h1 className="font-serif text-6xl md:text-8xl text-bone tracking-tight">
          {t("404.headline1")} <span className="italic text-gold">{t("404.headline2")}</span>
        </h1>
        <p className="mt-8 text-fog font-light max-w-md mx-auto leading-relaxed">
          {t("404.body")}
        </p>
        <Link
          to="/"
          data-testid="notfound-home-link"
          className="mt-10 inline-flex items-center gap-2 text-[12px] tracking-[0.2em] uppercase text-gold hover:text-gold-hover transition-colors"
        >
          <ArrowLeft size={14} strokeWidth={1.5} /> {t("404.return")}
        </Link>
      </div>
    </main>
  );
}
